import type { FaireProductEntity } from "../../entity_types/product";

export const p_ckqwke8hja: FaireProductEntity = {
  token: "p_ckqwke8hja",
  type: "product",
  name: "Dry Shampoo | Light Tones",
  brandToken: "b_hdz6pz52m7",
  brandName: "THYKK",
  imageUrl:
    "https://cdn.faire.com/fastly/1053ecccca740fe49d44c083db761feaeccef4ceaf4f12b6760637dad9d890d9.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b8fa485571f2d46eadcd73ccb5ea09f61f251fe02d2083d440e15f6a0c370438.png",
    "https://cdn.faire.com/fastly/3379c60d7cbc9c464825461bd53355660703f2609ec295e5a7ac73b020908552.png",
    "https://cdn.faire.com/fastly/a70597326ecbcbeee1973ad2a1ce908ed1a1836791923dccef099f8e584c939c.png",
  ],
  priceDollars: 14.5,
  description:
    "Hair color is personal. Dry shampoo should be too. By popular demand, Moroccanoil® launches its first-ever dry shampoo in two formulas, for Light Hair Tones and for Dark Hair Tones.\n\nMoroccanoil Dry Shampoo Light Tones contains ultra-fine rice starch that absorbs oil, buildup and odor, leaving hair instantly cleansed and refreshed. UV-protecting, argan oil-infused formula contains subtle violet undertones to balance brassiness in blonde hair and bring out the best in light tones.\n\nShake well. Spray Moroccanoil® Dry Shampoo 6-8 inches (15-20 cm) away from dry roots. Let dry, then massage into scalp as you would with wet shampoo. Brush out.\n",
  tags: [],
  msrpDollars: 29,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:34.475Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
